<template>
  <div :class="validationContainerClass">
    <v-validate
      :rules="rules"
      :vid="name"
      v-slot="{ errors, classes }"
      :name="label"
    >
      <div class="form-group k-rtl">
        <label :for="id">
          {{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i>
          </div>
        </label>
        <div :class="{ 'k-invalid-wrapper': classes.invalid }">
          <treeselect
            :id="inputID"
            dir="rtl"
            :ref="name"
            :multiple="checkboxes"
            :options="tree"
            :disabled="disabled"
            :placeholder="placeHolder || 'انتخاب کنید...'"
            :no-options-text="'موردی یافت نشد!'"
            :no-results-text="'موردی یافت نشد!'"
            :class="inputClass"
            :value="normalizedValue"
            @input="onTreeselectInput"
          />
        </div>
        <span v-if="hasSubtitle" class="form-text m-b-none">{{
          subtitle
        }}</span>
        <span
          class="invalid-feedback"
          :style="`display: ${errors ? 'inline-block' : 'none'}`"
          >{{ errors[0] }}</span
        >
      </div>
    </v-validate>
  </div>
</template>
<script>
import InputCommons from "./InputCommons.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  extends: InputCommons,
  components: { Treeselect },
  props: {
    checkboxes: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    tree() {
      return this.prepareTree(this.dataSource, 0, this.dataTextField, this.dataValueField);
    },
    // vue-treeselect requires `value` to strictly be an array when
    // `multiple` is true (it calls .slice()/.filter()/.forEach() on it
    // directly) — API data doesn't always guarantee that shape (e.g. a
    // single id instead of a one-item array), so normalize defensively
    // rather than trusting the raw v-model value.
    normalizedValue() {
      if (this.checkboxes) {
        if (Array.isArray(this.content)) return this.content;
        return this.content == null || this.content === "" ? [] : [this.content];
      }
      if (Array.isArray(this.content)) return this.content.length ? this.content[0] : null;
      return this.content;
    },
  },
  methods: {
    prepareTree(items, _parentValue = 0, _textField = "name", _valueField = "id") {
      var that = this;
      return (items || [])
        .filter((item) => Number(item.parent_id) === Number(_parentValue))
        .map((node) => {
          var children = that.prepareTree(items, node[_valueField], _textField, _valueField);
          return {
            id: node[_valueField],
            label: node[_textField],
            children: children.length ? children : undefined,
          };
        });
    },
    onTreeselectInput(val) {
      this.content = val;
      this.handleInput(val);
    },
    emptyKendo() {
      this.content = this.checkboxes ? [] : null;
      this.handleInput(this.content);
    },
  },
};
</script>
<style>
.vue-treeselect__control {
  min-height: 40px !important;
  height: auto !important;
  border-radius: 8px !important;
  border-color: #dfe3ea !important;
}

.vue-treeselect__multi-value {
  padding: 4px 0;
}

.vue-treeselect--focused .vue-treeselect__control,
.vue-treeselect--open .vue-treeselect__control {
  border-color: #4f46e5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12) !important;
}

.k-invalid-wrapper .vue-treeselect__control {
  border-color: #f04438 !important;
}

.vue-treeselect__multi-value-item {
  background-color: #eef2ff !important;
  color: #4f46e5 !important;
  border-radius: 6px !important;
}

.vue-treeselect__menu {
  border-radius: 10px !important;
  box-shadow: 0 10px 24px -6px rgba(15, 23, 42, 0.15) !important;
  border-color: #e9ecf1 !important;
}

.vue-treeselect__option--highlight,
.vue-treeselect__option--selected {
  background-color: #eef2ff !important;
}

.vue-treeselect__checkbox--checked .vue-treeselect__checkbox-arrow-container,
.vue-treeselect__checkbox--indeterminate .vue-treeselect__checkbox-arrow-container {
  background-color: #4f46e5 !important;
  border-color: #4f46e5 !important;
}
</style>
